import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isHighlighted", "children", "style", "testId"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { tableRowCSSVars as cssVars } from './dynamic-table';
var rowStyles = css({
  backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
  '&:focus-visible': {
    outline: "2px solid ".concat("var(--ds-border-focused, ".concat( // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    "var(".concat(cssVars.CSS_VAR_HOVER_BACKGROUND, ")"), ")")),
    outlineOffset: "-2px"
  }
});
var rowBackgroundStyles = css({
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat( // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    "var(".concat(cssVars.CSS_VAR_HOVER_BACKGROUND, ")"), ")")
  }
});
var rowHighlightedBackgroundStyles = css({
  backgroundColor: "var(--ds-background-selected, ".concat( // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  "var(".concat(cssVars.CSS_VAR_HIGHLIGHTED_BACKGROUND, ")"), ")"),
  '&:hover': {
    backgroundColor: "var(--ds-background-selected-hovered, ".concat( // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    "var(".concat(cssVars.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND, ")"), ")")
  }
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var TableBodyRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isHighlighted = _ref.isHighlighted,
    children = _ref.children,
    style = _ref.style,
    testId = _ref.testId,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx("tr", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: style,
    css: [rowStyles, isHighlighted ? rowHighlightedBackgroundStyles : rowBackgroundStyles]
  }, rest, {
    ref: ref,
    "data-testid": testId
  }), children);
});